// components/ChatSidebar.js
import { FULL_NAME, getDateSeparatorLabel } from "helpers/common";
import { Badge } from 'react-bootstrap';
import styles from './ChatSidebar.module.css';
import OnlineStatusDot from "./OnlineStatusDot";
import TiptapViewer from "components/shared/TiptapViewer";

const ChatSidebar = ({ conversations, selectedConversationId, onSelect }) => {

   // Sort conversations by latest_message_at DESC, nulls last
   const sortedConversations = [...conversations].sort((a, b) => {
    const dateA = a.latest_message_at ? new Date(a.latest_message_at) : null;
    const dateB = b.latest_message_at ? new Date(b.latest_message_at) : null;

    if (dateA && dateB) {
      return dateB - dateA; // Latest first
    }
    if (!dateA && !dateB) return 0;
    return dateA ? -1 : 1; // Put nulls at the end
  });

  return (
    <div className={styles.ChatSidebar}>
      <h5 className="p-3 border-bottom mb-0 text-white">Conversations</h5>
      <ul className="p-0 m-0">
        {sortedConversations.map((conv) => {
          const isActive = conv.conversation_id === selectedConversationId;
          const clientFullName = FULL_NAME(conv.client_first_name, conv.client_last_name);
          const unreadCount = conv.unread_count;
          const isOnline = conv.active_status;
          const latestMessageDate =
            conv.latest_message_at ? getDateSeparatorLabel(conv.latest_message_at, true, "MM/DD/YYYY") : null;

          return (
            <li
              key={conv.conversation_id}
              onClick={() => onSelect(conv)}
              className={`ps-3 py-2 d-flex justify-content-between align-items-start ${isActive ? styles.activeChat : styles.chatListItem}`}
              style={{ cursor: 'pointer' }}
            >
              <div className="me-auto position-relative">
                <OnlineStatusDot isOnline={isOnline} />
                <div className={styles.ConversationTitle}>
                  {clientFullName}
                </div>
                  <div className="text-muted text-truncate text-white-50 text-truncate" style={{ maxWidth: '180px', height: "20px" }}>
                    {conv.is_latest_message_deleted ? (
                      <p className="m-0 message-deleted font-italic"><i>(This message has been deleted)</i></p>
                    ): conv.message ? (
                      <TiptapViewer
                        content={conv.message}
                      />
                    ):(
                      <p className="m-0">No message yet</p>
                    )}
                  </div>
              </div>
                <div className="position-relative text-end">
                  {unreadCount > 0 && (
                    <Badge bg="danger" pill style={{
                      position: "absolute",
                      right: "10px",
                      top: "5px",
                      // minWidth: 24,
                    }}>
                      {unreadCount}
                    </Badge>
                  )}
                  {latestMessageDate && (
                    <small className="text-white-50 text-end" style={{
                      position: "absolute",
                      bottom: "0px",
                      right: "10px",
                      width: "70px",
                      top: "22px",
                    }}>
                      {latestMessageDate}
                    </small>
                  )}
                </div>
            </li>
          );
        })}
      </ul>
      <div className={styles.SecuredMsgContainer}>
        <p className={styles.SecuredMsg}>Your messages are encrypted</p>
      </div>
    </div>
  );
};

export default ChatSidebar;
